export const API_URL = "https://demo-wa-ecommerce-backend-aarmor.azurewebsites.net/api/";
